import { DS } from "../../../../theme-default";
import React from "react";
import { SkyLightStateless } from "react-skylight";
import Select from "react-select";
import { RaisedButton, TextField } from "material-ui";
import { Constants } from "../../../../constants";
import { styles } from "../../../menu/styles";
import Header from "../../../header";
import RedirectIfNotLogged from "../../../menu/redirect-if-not-logged";
import request from "../../../../config/axios-config";
import {
  DEFAULT_INFO_LABELS,
  PRINT_BANDS,
  SERVER_ERRORS,
  STEP_TYPE_DEPARTMENT_CHIEF,
  STEP_TYPE_USER,
  fallbackOptions,
  flowStepPayload,
  formFromStep,
  validateFlowStep,
  withSigner,
} from "./flow-step-form";

const errorStyle = { fontSize: "12px", color: DS.error, marginTop: "5px" };
const hintStyle = { fontSize: "12px", color: DS.textMuted, marginTop: "5px" };

export default class FlowModalComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: true,
      form: formFromStep(props.step),
      userEmails: [],
      error: {},
    };
  }

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
    });
    this.props.onCancel();
  };

  componentDidMount() {
    let users = this.props.users ? this.props.users : [];
    let userEmails = users.map((t) => {
      return { value: t.id, label: t.email };
    });
    this.setState({ userEmails: userEmails });
  }

  updateForm = (changes) => {
    this.setState((oldState) => ({ form: { ...oldState.form, ...changes } }));
  };

  onSave = () => {
    const error = validateFlowStep(this.state.form);
    this.setState({ error: error });
    if (Object.keys(error).length > 0) {
      return;
    }

    request({
      method: "POST",
      url: Constants.SERVER_ENDPOINT + "/flow/add/step",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      data: flowStepPayload(
        this.state.form,
        this.props.flowId,
        this.props.step ? this.props.step.id : null
      ),
    })
      .then(() => {
        this.closeModal();
      })
      .catch((err) => {
        // The API answers {code, message, errorMessage, response}; message carries the code.
        const code =
          err && err.response && err.response.data && err.response.data.message;
        this.setState({
          modalIsOpen: true,
          error: { server: SERVER_ERRORS[code] || "Pasul nu a putut fi salvat." },
        });
      });
  };

  render() {
    const form = this.state.form;
    const chief = form.stepType === STEP_TYPE_DEPARTMENT_CHIEF;
    const info = !chief && !!form.infoStep;
    return (
      <div>
        <RedirectIfNotLogged />

        <SkyLightStateless
          isVisible={this.state.modalIsOpen}
          dialogStyles={{
            ...styles.defaultDialogStyles,
            padding: "50px",
          }}
          onCloseClicked={this.closeModal}
          onOverlayClicked={this.closeModal}
          title={<Header title={this.props.step ? "Editare pas" : "Pas nou"} />}
        >
          <div>
            <table className="table  table-hover">
              <tbody>
                <tr>
                  <td>Numar ordine</td>
                  <td>
                    <TextField
                      type="number"
                      hintText={"Numarul de ordine"}
                      value={form.orderNumber}
                      errorText={this.state.error.orderNumber}
                      onChange={(e) => this.updateForm({ orderNumber: e.target.value })}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Cine aprobă</td>
                  <td>
                    <label style={{ marginRight: "20px" }}>
                      <input
                        type="radio"
                        name="step-type"
                        checked={!chief}
                        onChange={() => this.updateForm({ stepType: STEP_TYPE_USER })}
                      />{" "}
                      O persoană anume
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="step-type"
                        checked={chief}
                        onChange={() => this.updateForm({ stepType: STEP_TYPE_DEPARTMENT_CHIEF })}
                      />{" "}
                      Șeful departamentului care a întocmit referatul
                    </label>
                    {chief && (
                      <div style={{ fontSize: "12px", marginTop: "5px" }}>
                        Oricare dintre șefii departamentului poate aproba. Dacă
                        departamentul nu are șef, pasul este sărit.
                      </div>
                    )}
                  </td>
                </tr>

                {!chief && (
                  <tr>
                    <td>Email</td>
                    <td>
                      <div>
                        <Select
                          autoFocus
                          options={this.state.userEmails}
                          simpleValue
                          clearable={true}
                          name="signed-by"
                          value={form.selectedUserId}
                          onChange={(val) =>
                            this.setState((oldState) => ({ form: withSigner(oldState.form, val) }))
                          }
                          searchable={true}
                        />
                        {this.state.error.signedById && (
                          <div style={errorStyle}>{this.state.error.signedById}</div>
                        )}
                      </div>
                    </td>
                  </tr>
                )}

                {!chief && (
                  <tr>
                    <td>Înlocuitori (opțional)</td>
                    <td>
                      <div>
                        <Select
                          multi
                          options={fallbackOptions(this.props.users, form)}
                          name="fallbacks"
                          value={form.fallbackIds}
                          placeholder="Fără înlocuitori"
                          onChange={(selected) =>
                            this.updateForm({
                              fallbackIds: (selected || []).map((option) => option.value),
                            })
                          }
                          searchable={true}
                        />
                        <div style={hintStyle}>
                          Oricare dintre ei poate aproba în locul persoanei; primul care
                          aprobă închide pasul. Văd referatele ca aprobatorii.
                        </div>
                        {this.state.error.fallbacks && (
                          <div style={errorStyle}>{this.state.error.fallbacks}</div>
                        )}
                      </div>
                    </td>
                  </tr>
                )}

                {!chief && (
                  <tr>
                    <td>Ce face persoana</td>
                    <td>
                      <label style={{ marginRight: "20px" }}>
                        <input
                          type="radio"
                          name="step-kind"
                          checked={!info}
                          onChange={() => this.updateForm({ infoStep: false })}
                        />{" "}
                        Aprobă sau respinge
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="step-kind"
                          checked={info}
                          onChange={() =>
                            this.updateForm({
                              infoStep: true,
                              infoLabelsText: form.infoLabelsText || DEFAULT_INFO_LABELS,
                            })
                          }
                        />{" "}
                        Completează informații (fără aprobare)
                      </label>
                      {info && (
                        <div>
                          <textarea
                            rows={4}
                            style={{ width: "100%", marginTop: "8px" }}
                            value={form.infoLabelsText}
                            onChange={(e) => this.updateForm({ infoLabelsText: e.target.value })}
                          />
                          <div style={hintStyle}>
                            Câte un rând pe linie (cel mult 5). Persoana nu aprobă și nu respinge: completează
                            toate rândurile și salvează. Rândul „Sumă” pornește cu totalul cu TVA al referatului.
                            Pe tipărire, rândurile apar după semnăturile din zona aleasă mai jos.
                          </div>
                          {this.state.error.infoLabels && (
                            <div style={errorStyle}>{this.state.error.infoLabels}</div>
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                )}

                <tr>
                  <td>Titlu</td>
                  <td>
                    <TextField
                      hintText={"Exemplu: AVIZAT"}
                      value={form.calling}
                      errorText={this.state.error.calling}
                      onChange={(e) => this.updateForm({ calling: e.target.value })}
                    />
                  </td>
                </tr>

                {!info && (
                  <tr>
                    <td>Poate edita continutul?</td>
                    <td>
                      <input
                        type="checkbox"
                        checked={form.canEditPapers}
                        onChange={() => this.updateForm({ canEditPapers: !form.canEditPapers })}
                      />
                    </td>
                  </tr>
                )}

                {!info && (
                  <tr>
                    <td>Poate edita articolul bugetar?</td>
                    <td>
                      <input
                        type="checkbox"
                        checked={form.canSetArticolBugetar}
                        onChange={() =>
                          this.updateForm({ canSetArticolBugetar: !form.canSetArticolBugetar })
                        }
                      />
                    </td>
                  </tr>
                )}

                {!chief && !info && (
                  <tr>
                    <td>Înregistrează referatul?</td>
                    <td>
                      <input
                        type="checkbox"
                        checked={!!form.canSetRegistrationNumber}
                        onChange={() =>
                          this.updateForm({ canSetRegistrationNumber: !form.canSetRegistrationNumber })
                        }
                      />
                      <div style={hintStyle}>
                        La aprobare, persoana completează numărul de înregistrare (apare pe tipărire).
                      </div>
                    </td>
                  </tr>
                )}

                <tr>
                  <td>Pe tipărire (format configurabil)</td>
                  <td>
                    <select
                      value={form.printBand}
                      onChange={(e) => this.updateForm({ printBand: e.target.value })}
                    >
                      {PRINT_BANDS.map((band) => (
                        <option key={band.value} value={band.value}>
                          {band.label}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td>
                    <RaisedButton
                      primary
                      label={"Save"}
                      onClick={() => this.onSave()}
                    />
                    {this.state.error.server && (
                      <div style={errorStyle}>{this.state.error.server}</div>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </SkyLightStateless>
      </div>
    );
  }
}
